export const EMPTY_NEWS_FORM = {
  title_ar: "",
  title_en: "",
  content_ar: "",
  content_en: "",
};
